import { render, staticRenderFns } from "./mItems.vue?vue&type=template&id=5b04b663&scoped=true&"
import script from "./mItems.vue?vue&type=script&lang=js&"
export * from "./mItems.vue?vue&type=script&lang=js&"
import style0 from "./mItems.vue?vue&type=style&index=0&id=5b04b663&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b04b663",
  null
  
)

export default component.exports